import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {FileEntry} from "../interfaces/fileEntry";
import {APIService} from "../shared/api.service";
import { DomSanitizer } from "@angular/platform-browser";
import {AuthService} from "../shared/auth.service";
import { saveAs as importedSaveAs } from "file-saver-es";
import {NotifierService} from "../shared/notifier.service";

@Component({
    selector: 'bst-file-preview',
    templateUrl: './file-preview.component.html',
    styleUrls: ['./file-preview.component.scss'],
    standalone: false
})
export class FilePreviewComponent implements OnInit {

  @ViewChild('form', {static: true}) public form: ElementRef<HTMLFormElement>;

  @Input() public file: FileEntry = null;
  @Input() public width: number = 230;
  @Input() public height: number = 300;

  private source;
  private txt;
  private loading = false;

  constructor(private api: APIService,
              public auth: AuthService,
              private notifier: NotifierService,
              private sanitizer: DomSanitizer) {
  }

  public get target(){
    if(this.file) {
      return '/file/' + this.file.id;
    }
    return '/';
  }

  public get isLoading(){
    return this.loading;
  }

  public get src(){
    return this.source;
  }

  public get text(){
    return this.txt;
  }

  ngOnInit(): void {
    if(this.file){
      this.loading = true;
      if(this.file){
        this.txt = this.file.name;
      }

      this.api.preview(this.file.id).then((data: Blob) => {
        const unsafeImageUrl = URL.createObjectURL(new Blob([data], {type: 'image/jpeg'}));
        this.source = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
        this.loading = false;
      }).catch((error) => {
        console.error(error);
        this.loading = false;
      });
    }
  }

  public get(local: boolean = false) {
    if(this.file){
      if(local) {
        this.api.download(this.file.id).then((item: Blob) => {
          importedSaveAs(item, this.file.name);
          return this.notifier.notify(this.file.name, 'uploaddownload', 'primary', 'file-outline');
        }).catch((error) => {
          console.error(error);
          return this.notifier.notify('error', null, 'danger');
        });
      }
      else{
        this.form.nativeElement.submit();
      }
    }
  }
}
